// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class Choice {
  public value!: string;

  public position!: number;

  public static fromDto(dto: any): Choice {
    const choice: Choice = new Choice();
    choice.value = dto.value;
    choice.position = dto.position;
    return choice;
  }
}
